import React, { FC } from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import {
  getSectionFieldNames,
  countIncompleteRequiredFields,
  getSectionChat,
  countChangedFields,
} from "@/onboarding/features/product/selectors"
import { ReservedSections } from "@/onboarding/features/product/models/Product"

import SectionHolder from "./shared/SectionHolder"
import Content from "./web_content/Content"
import Edit from "./web_content/Edit"

const WebContent: FC = () => {
  const fieldNames = useSelector(getSectionFieldNames.description)
  const incompleteFieldCount = useSelector(countIncompleteRequiredFields(...fieldNames))
  const sectionChat = useSelector(getSectionChat(_.snakeCase("description")))
  const proposedChangesCount = useSelector(countChangedFields(...fieldNames))

  return (
    <SectionHolder
      title="Web Content"
      name={ReservedSections.DESCRIPTION}
      editComponent={Edit}
      editMethod="inline"
      importableFields={fieldNames}
      incompleteRequiredFieldCount={incompleteFieldCount}
      proposedChangesCount={proposedChangesCount}
      chat={sectionChat}
    >
      <Content />
    </SectionHolder>
  )
}

export default WebContent
